import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import registerServiceWorker from './registerServiceWorker';
import * as Sentry from '@sentry/browser';
import ReactGA from 'react-ga'

Sentry.init({dsn: "https://913f96bf11304283939d81e40e4ca58a@o464051.ingest.sentry.io/5473250"});

ReactGA.initialize('UA-113313413-9')


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// registerServiceWorker()
